// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text-dark-grey-1[data-v-89bfa316]{color:#454545}", "",{"version":3,"sources":["webpack://./resources/assets/js/components/auth/EmailVerification.vue"],"names":[],"mappings":"AACA,mCACI,aAAA","sourcesContent":["\n.text-dark-grey-1 {\n    color: #454545\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
